import { useId, useRef } from 'react'
import Modal from 'react-bootstrap/Modal'

export const FullScreenModal = (props) => {
  const { children, onClose, show } = props
  const id = useId()
  const ref = useRef()

  return (
    <Modal show={show} onHide={onClose} fullscreen ref={ref} id={id}>
      <Modal.Header closeButton />
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  )
}
